import React, { useEffect, useState } from "react";
import { Button, Input, message, Modal, Spin } from "antd";
import Camera from "react-html5-camera-photo";
import "react-html5-camera-photo/build/css/index.css";
import { apiCall } from "../lib/frNetworkHelper";
import dataUriToBlob from "../utils/dataUriToBlob";
import { useSelector } from "react-redux";
import { verifyFrPassword } from "../lib/frSettingsHelper";

const toErrorText = value => {
  if (typeof value === "string") return value;
  if (typeof value === "number" || typeof value === "boolean")
    return String(value);
  if (value && typeof value === "object") {
    if (typeof value.message === "string") return value.message;
    if (typeof value.error === "string") return value.error;
    if (value.error && typeof value.error.message === "string")
      return value.error.message;
  }
  return "";
};

const getErrorMessage = (err, fallback) =>
  toErrorText(err && err.data && err.data.error) ||
  toErrorText(err && err.data && err.data.message) ||
  fallback;

export default function FaceAuth({ visible, onClose, onNext, customerUserCode }) {
  const userData = useSelector(state => state.authState.userData);
  const BUSINESS_ID = userData.business_id;

  const [loading, setLoading] = useState(false);
  const [recognizeResult, setRecognizeResult] = useState(null);
  const [bypassVisible, setBypassVisible] = useState(false);
  const [bypassInput, setBypassInput] = useState("");
  const [verifying, setVerifying] = useState(false);

  const recognizeFromDataUri = dataUri => {
    if (!dataUri) return;
    const blob = dataUriToBlob(dataUri);
    if (!blob) {
      alert("Failed to read captured image");
      return;
    }

    const form = new FormData();
    form.append("image", blob, "photo.jpg");

    setLoading(true);

    apiCall(
      BUSINESS_ID,
      "persons/recognize",
      "post",
      form,
      resp => {
        setRecognizeResult(resp.data);
        onNext(resp.data);
      },
      err => {
        const msg = getErrorMessage(err, "Recognition failed");
        message.error(msg);
        setRecognizeResult({ error: msg });
      },
      () => {
        setLoading(false);
      }
    );
  };

  const handleBypassConfirm = async () => {
    if (!bypassInput) {
      message.error("Password harus diisi");
      return;
    }
    setVerifying(true);
    const valid = await verifyFrPassword(
      userData.business_id,
      userData.outlet_id,
      "bypass",
      bypassInput
    );
    setVerifying(false);
    if (valid) {
      onNext({ match: { externalUserId: customerUserCode }, bypass: true });
      setBypassVisible(false);
      setBypassInput("");
    } else {
      message.error("Password bypass salah");
    }
  };

  useEffect(() => {
    if (!visible || !recognizeResult) return;
  }, [visible, recognizeResult]);

  useEffect(() => {
    if (!visible) {
      setBypassVisible(false);
      setBypassInput("");
    }
  }, [visible]);

  return (
    <>
      <Modal
        title="Face Recognition"
        visible={visible}
        footer={null}
        onCancel={onClose}
      >
        <Spin spinning={loading}>
          {visible && (
            <Camera
              onTakePhotoAnimationDone={dataUri => {
                recognizeFromDataUri(dataUri);
              }}
              isImageMirror={true}
            />
          )}
          {userData.fr_has_bypass_password && (
            <div style={{ textAlign: "center", marginTop: 12 }}>
              <Button type="link" onClick={() => setBypassVisible(true)}>
                Bypass dengan password
              </Button>
            </div>
          )}
        </Spin>
      </Modal>

      <Modal
        title="Bypass Face Recognition"
        visible={bypassVisible}
        onOk={handleBypassConfirm}
        confirmLoading={verifying}
        onCancel={() => {
          setBypassVisible(false);
          setBypassInput("");
        }}
        okText="Konfirmasi"
      >
        <Input.Password
          placeholder="Masukkan password bypass"
          value={bypassInput}
          onChange={e => setBypassInput(e.target.value)}
          onPressEnter={handleBypassConfirm}
          disabled={verifying}
        />
      </Modal>
    </>
  );
}
